<template>
    <div class="nada-schedule" :class="isMounted ? 'active' : ''">
        <div class="relative" :class="scheduleLoading ? 'loading' : ''">
            <div v-if="scheduleData">
                <div class="loader loading-on"><span class="visuallyhidden">Loading</span></div>
                
                <h2 class="schedule-title loading-off">
                    <span v-if="scheduleData['willAttend']">Here’s What You’ve Signed Up&nbsp;For:</span>
                    <span v-if="!scheduleData['willAttend']">Here are the Demos You’ve Requested Information&nbsp;About:</span>
                </h2>

                <p class="breathe-mini" v-if="email">
                    {{getTranslation('schedule_email')}}<br />
                    <strong>{{email}}</strong>
                </p>

                <h4 v-if="scheduleData['willAttend'] && scheduleData['main_brand_slug'] !== 'hub'" class="schedule-booth">
                    {{ scheduleData['main_brand_name'] }}
                </h4>

                <div v-if="scheduleData['brands'] && (scheduleData['brands'].length || Object.keys(scheduleData['brands']).length)">
                    <div v-for="brand_key in Object.keys(scheduleData['brands'])" :key="brand_key" style="margin-bottom: 20px;">
                        <h4 class="schedule-booth">{{scheduleData['brands'][brand_key].brand_name}}</h4>

                        <ul class="schedule-list">
                            <template v-for="demo in scheduleData['brands'][brand_key].products" :key="demo.ID">
                                <li v-if="scheduleData['brands'][brand_key].brand_name !== demo.title || (scheduleData['brands'][brand_key].products.length > 1)">
                                    {{demo.title}}
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>

                <template v-if="scheduleData['main_brand_slug'] === 'hub'">
                    <h4 v-for="brand in scheduleData['recommended_brands']" :key="brand.brand_value" class="schedule-booth breathe-bottom">
                        {{brand.brand_name}}
                    </h4>
                </template>

                <template v-else>
                    <h4 class="schedule-booth" v-if="scheduleData['recommended_brands']?.length">
                        <span>Additional brands:</span>
                    </h4>
    
                    <div v-if="scheduleData['recommended_brands']?.length">
                        <ul class="schedule-list" style="margin-bottom: 20px;">
                            <li v-for="brand in scheduleData['recommended_brands']" :key="brand.brand_value">
                                {{brand.brand_name}}
                            </li>
                        </ul>
                    </div>
                </template>
            </div>
        </div>

        <p v-if="scheduleData && !scheduleData['willAttend']">{{getTranslation('representative_will_contact')}}</p>
    </div>
</template>

<script>
    import Request from '../lib/atd-request.js';
    import { getUrlParameter } from '../lib/utils.js';

    import { translations } from '../data/translations.js';

    const API_URL = window.atdTradeshows.api_domain;

    export default {
        props: {},
        data() {
            return {
                mode: null,
                email: null,
                scheduleData : null,
                scheduleLoading: true,
                submissionId: null,
                translations: translations,
                language: 'en',
                isMounted: false
            }
        },
        components: {},
        computed: {},
        mounted() {
            this.isMounted = true;
            this.submissionId = getUrlParameter('submissionId');

            if(this.submissionId) {
                this.getScehdule(this.submissionId);
            }
        },
        methods: {
            getScehdule: function(submissionId) {
                this.setLoading(true);

                Request.get(`${API_URL}/wp-json/atd/nada-submission/schedule/${submissionId}`, {'Cache-Control': 'no-cache'})
                    .then((response) => {
                        return JSON.parse(response);
                    })
                    .then((schedule) => {
                        this.scheduleData = schedule;
                        this.language = this.scheduleData.language || 'en';

                        delete this.scheduleData.Country;
                        delete this.scheduleData.language;

                        this.setLoading(false);
                    });
            },

            setLoading(isLoading) {
                this.scheduleLoading = isLoading;
            },

            getTranslation(id) {
                if(!this.translations[id] || !this.translations[id][this.language]) {
                    return '';
                }
                
                return this.translations[id][this.language];
            }
        }
    }            
</script>
